import { api } from '@/api';
import { OpoUserInvitationOperationResponse } from '@/api/apis/opo';
import { wrapMutationForEntityDelete } from '@/queries/utils';
import { useDeleteOpoMutation, useDeleteOpoContactMutation } from '@/queries/opo/opo.mutation';

export const useWrappedDeleteOpoMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useDeleteOpoMutation);

  return wrappedMutation();
};

export const useWrappedDeleteOpoContactMutation = () => {
  const wrappedMutation = wrapMutationForEntityDelete(useDeleteOpoContactMutation);

  return wrappedMutation();
};

export const waitForOpoOperationResolve = async (job?: OpoUserInvitationOperationResponse) => {
  if (!job?.correlationId) {
    return job;
  }

  return new Promise((resolve, reject) => {
    const intervalId = setInterval(async () => {
      const operation = await api.opo.getOperationStatus(job.correlationId, job.flowType);

      if (operation.status === 'Completed') {
        resolve(operation);
        clearInterval(intervalId);
      } else if (operation.status === 'Failed') {
        reject(Error(operation.errorMessage!));
        clearInterval(intervalId);
      }
    }, 1000);
  });
};
